import MessagesPage from "../components/MessagesPage";

export default function InternPage() {

  return (
    <div className="min-h-screen bg-[#F8FAFA]">

      <main
        className="
          mx-auto
          max-w-7xl
          px-6
          py-10
        "
      >

        {/* DIALOGFORUM */}

        <section>
          <MessagesPage />
        </section>

      </main>

    </div>
  );
}